// Application Constants
export const APP_NAME = 'Diamond Admin'
export const APP_VERSION = '1.0.0'

// API Configuration — use the canonical export from config/api.js instead
// Re-exported here for backwards compatibility
export { API_BASE_URL } from '../config/api'

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  USERS: '/users',
  ACCOUNTS: '/accounts',
}

// Color Utilities
export const getColorVariable = (colorName) => {
  return getComputedStyle(document.documentElement).getPropertyValue(`--${colorName}`).trim()
}

// Amount Formatting — strips trailing zeros: 456.00 → 456, 456.50 → 456.5
export const formatAmount = (value) => {
  if (value === undefined || value === null || value === '-') return '-';
  const num = parseFloat(Number(value).toFixed(2));
  return isNaN(num) ? '-' : num.toString();
}

